export default __webpack_public_path__ + "static/media/jupi4.a57df698.png";